/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { showSnackbar } from '../store/snackbarSlice';
import { useDispatch } from 'react-redux';
import { usePermissions } from './PermissionsContext';

const ProtectedRoute = ({ component: Component, permissionKey }) => {
  const { permissions } = usePermissions();
  const [isLoading, setIsLoading] = useState(true);
  const token = sessionStorage.getItem('token');
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
      if (!token) {
        dispatch(showSnackbar({ message: 'You need to log in to access this page.', severity: 'warning' }));
      }
    }, 200); // Adjust delay as needed

    return () => clearTimeout(timer);
  }, [token]);

  if (isLoading) {
    return null; // Show nothing or a loader
  }

  if (!token) {
    return <Navigate to="/" replace />;
  }

 // Check if the user has the required permission
if (!permissions?.routing?.[permissionKey]) {
  dispatch(showSnackbar({ 
    message: 'Access Denied: You do not have permission to view this page.', 
    severity: 'error' 
  }));
  
  return null; // Prevents rendering without navigating away
}


  return <Component />;
};

export default ProtectedRoute;
